/* eslint-disable no-useless-escape */
import { chain, size, lt, concat, eq, negate, isNull, template, isUndefined, assign } from 'lodash';

const browserRules = [
  { name: 'aol', rule: /AOLShield\/([0-9\._]+)/ },
  { name: 'edge', rule: /Edge\/([0-9\._]+)/ },
  { name: 'yandexbrowser', rule: /YaBrowser\/([0-9\._]+)/ },
  { name: 'vivaldi', rule: /Vivaldi\/([0-9\.]+)/ },
  { name: 'kakaotalk', rule: /KAKAOTALK\s([0-9\.]+)/ },
  { name: 'samsung', rule: /SamsungBrowser\/([0-9\.]+)/ },
  { name: 'chrome', rule: /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ },
  { name: 'phantomjs', rule: /PhantomJS\/([0-9\.]+)(:?\s|$)/ },
  { name: 'crios', rule: /CriOS\/([0-9\.]+)(:?\s|$)/ },
  { name: 'firefox', rule: /Firefox\/([0-9\.]+)(?:\s|$)/ },
  { name: 'fxios', rule: /FxiOS\/([0-9\.]+)/ },
  { name: 'opera', rule: /Opera\/([0-9\.]+)(?:\s|$)/ },
  { name: 'opera', rule: /OPR\/([0-9\.]+)(:?\s|$)$/ },
  { name: 'ie', rule: /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ },
  { name: 'ie', rule: /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ },
  { name: 'ie', rule: /MSIE\s(7\.0)/ },
  { name: 'bb10', rule: /BB10;\sTouch.*Version\/([0-9\.]+)/ },
  { name: 'android', rule: /Android\s([0-9\.]+)/ },
  { name: 'ios', rule: /Version\/([0-9\._]+).*Mobile.*Safari.*/ },
  { name: 'safari', rule: /Version\/([0-9\._]+).*Safari/ },
  { name: 'facebook', rule: /FBAV\/([0-9\.]+)/ },
  { name: 'instagram', rule: /Instagram\s([0-9\.]+)/ },
  { name: 'ios-webview', rule: /AppleWebKit\/([0-9\.]+).*Mobile/ },
];

const getVersion = (matchBrowser) => {
  return chain(matchBrowser)
    .get(1)
    .split(/[._]/)
    .slice(0, 3)
    .thru(version => {
      const sizeVersion = size(version);

      return lt(sizeVersion, 3)
        ? concat(version, (eq(sizeVersion, 1) ? [0, 0] : [0]))
        : version;
    })
    .join('.')
    .value();
};

const detectedBrowser = () => {
  if (isUndefined(typeof navigator) && isNull(navigator.userAgent)) return null;

  return chain(browserRules)
    .reduce((result, browser) => {
      const match = browser.rule.exec(navigator.userAgent);
      if (negate(isNull)(match)) {
        result = assign(result, {
          name: browser.name,
          version: getVersion(match)
        });
      }
      
      return result 
    }, null)
    .value();
};

export const getBrowser = () => {
  const browser = detectedBrowser();
  const outputTemplate = template('<%= name %> <%= version %>');

  if (negate(isNull)(browser)) {   
    return outputTemplate({ name: browser.name, version: browser.version });
  }

  return outputTemplate({ name: 'Browser', version: 'undefined' });
};